import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import useMeasure from "react-use-measure";
import { getMealAmountAndUnit } from "../../helpers";
import { formatDistance, formatDuration, formatExercisePrefix, formatSteps } from "../../helpers/domain";

const DiaryItemList = ({ isOpen, onOpenModal, items = [], isExercise }) => {
	const [ref, { height }] = useMeasure();
	const [visualOpen, setVisualOpen] = useState(false);

	useEffect(() => {
		if (isOpen) setVisualOpen(true);
		else {
			const timer = setTimeout(() => setVisualOpen(false), 280);
			return () => clearTimeout(timer);
		}
	}, [isOpen]);

	const shouldRoundBottom = !items.length && visualOpen;

	return (
		<motion.div
			className={`diary-items-wrapper ${shouldRoundBottom ? "rounded-bottom" : ""}`}
			initial={false}
			animate={{
				height: isOpen ? height : 0,
			}}
			transition={{
				duration: 0.3,
				ease: "easeInOut",
			}}
			style={{ overflow: "hidden" }}
		>
			<div ref={ref}>
				<div className="diary-items-container">
					{items.length === 0 ? (
						<ul className="empty-list">
							<li className="no-items">
								Inget registrerat för denna dagen. <br />
								Klicka på plus-ikonen för att lägga till {!isExercise ? "måltid" : "träning"}.
							</li>
						</ul>
					) : (
						<ul>
							{items.map((item, index) => {
								const key = `${item.id ?? item.food_item_id ?? "x"}-${index}`;
								const amountAndUnit = getMealAmountAndUnit(item);

								if (isExercise) {
									const type = Number(item.type);
									const isSteps = type === 2;

									const formattedDistance = formatDistance(item.distance_km);
									const formattedSteps = formatSteps(item.steps);
									const duration = formatDuration(item.duration);

									return (
										<li key={key}>
											<div className="diary-item no-hover">
												<div className="item-left">
													<span>
														{formatExercisePrefix({
															isSteps,
															time: item.time,
															duration,
															distance: formattedDistance,
														})}{" "}
													</span>
													{!isSteps ? item.name : formattedSteps}
												</div>
												<span className="item-right">
													{Math.round(item.kcal)} kcal
												</span>
											</div>
										</li>
									);
								}

								return (
									<li key={key} className="diary-item" onClick={() => onOpenModal(item)}>
										<div className="item-left">
											{amountAndUnit && <span className="amount">{amountAndUnit}</span>}{" "}
											<span className="item-name">{item.name}</span>
										</div>
										<span className="item-right">{Math.round(item.kcal)} kcal</span>
									</li>
								);
							})}
						</ul>
					)}
				</div>
			</div>
		</motion.div>
	);
};

export default DiaryItemList;
